type StorageValue = string | number | boolean | object | null;

export const storage = {
    get<T>(key: string, fallback?: T): T | null {
        try {
            const item = localStorage.getItem(key);
            if (item === null) return fallback ?? null;
            return JSON.parse(item) as T;
        } catch (e) {
            console.error("storage.get error:", e);
            return fallback ?? null;
        }
    },

    set<T extends StorageValue>(key: string, value: T): void {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.error("storage.set error:", e);
        }
    },

    remove(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.error("storage.remove error:", e);
        }
    },

    clear(): void {
        try {
            localStorage.clear();
        } catch (e) {
            console.error("storage.clear error:", e);
        }
    },

    has(key: string): boolean {
        try {
            return localStorage.getItem(key) !== null;
        } catch (e) {
            console.error("storage.has error:", e);
            return false;
        }
    },
};
